
import React, {FC} from 'react';
import classNames from 'classnames';

import * as styles from './styles.module.scss';

type IconProps = {
	className: string
}

const Icon: FC<IconProps> = ({className}) => {
	return (
		<svg
			className={className}
			width='10' height='12' viewBox='0 0 10 12' fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M9 7.11117L5 11.0001M5 11.0001L0.999999 7.11117M5 11.0001L5 1.00006'
				strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'
			/>
		</svg>
	);
};

export type ArrowColor = 'standard' | 'reverse' | 'neutral';

type ArrowProps = {
	curr: {value: number}
	prev: {value: number} | null
	color: ArrowColor
}

const Arrow: FC<ArrowProps> = ({curr, prev, color}) => {
	if (prev === null) {
		return <div />;
	}

	const up = curr.value > prev.value;
	const down = curr.value < prev.value;
	const neutral = color === 'neutral';
	const good = !neutral && (color === 'reverse' ? up : down);
	const bad = !neutral && !good;

	return (
		<Icon className={classNames({
			[styles.up]: up,
			[styles.down]: down,
			[styles.neutral]: neutral,
			[styles.good]: good,
			[styles.bad]: bad,
		})} />
	);
};

export default Arrow;
